export default "__VITE_ASSET__BhalFI2b__"